module.exports = __webpack_public_path__ + "static/media/01.4139ac54.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/01.jpg
// module id = 563
// module chunks = 0